export default "__VITE_ASSET__CXM5GNTi__"